import React, {useEffect, useState} from "react";
import * as StorageService from "../../services/StorageService.js";
import {LOCALSTORAGE_ITEMS} from "../../util/Constants";
import * as UserService from "../../services/UserService";

function OrderSummActionsBar(props) {
    const hasMultiOrders = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).merchantConfig.multiOrders:null;

    const [state, setState] = useState({
        hasMultiOrdersTable:false
    });

    useEffect( () => {
        if (hasMultiOrders === false) {
             getTableById().then(tableResponse =>{
                setState({
                    ...state,
                    hasMultiOrdersTable: tableResponse.data.multiOrders
                })
            });
        }

    }, []);

    const getTableById = async () => {
        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "tid":StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE)
        }
        const response = await UserService.getTableById(body);
        if (response.ok) {
            console.log("getTableById: ", response.data);
        } else {
            console.log("Error getTableById");
        }
        return response;
    }






    return (
        <div className={props.isVisible ? "actionsbar show" : "actionsbar"}>
            {
                hasMultiOrders || state.hasMultiOrdersTable?
                    <div className="row buttons-row">
                        <a className={props.btnClassName} data-qa={props.dataQAIdentifier1} onClick={props.buttonAction}>
                            {props.buttonName}
                        </a>

                        <a data-qa={props.dataQAIdentifier2} className={props.btnClassName2} onClick={props.buttonAction2}>
                            {props.buttonName2}
                        </a>
                    </div>
                    :
                    <div className="row buttons-row">
                        <a className="btn btn-default btn-xl" data-qa={props.dataQAIdentifier1} onClick={props.buttonAction}>
                            {props.buttonName}
                        </a>
                    </div>
            }

        </div>
    );
}

export default OrderSummActionsBar;
